export interface BackoffOptions {
  initialMs: number;
  maxMs: number;
  /** 0…1; the delay is randomised by ±jitter/2 to spread reconnects. */
  jitter: number;
}

export const DEFAULT_BACKOFF: BackoffOptions = { initialMs: 1000, maxMs: 30_000, jitter: 0.3 };

/** Exponential backoff delay for the given attempt (0-based). */
export function backoffDelay(
  attempt: number,
  options: BackoffOptions = DEFAULT_BACKOFF,
  random: () => number = Math.random,
): number {
  const base = Math.min(options.maxMs, options.initialMs * 2 ** Math.max(0, attempt));
  const factor = 1 + options.jitter * (random() - 0.5);
  return Math.round(Math.min(options.maxMs, base * factor));
}
